export default "__VITE_ASSET__CPNyPrEC__"